// extracted by mini-css-extract-plugin
export default {"wrapper":"VerificationEdit_wrapper__Bo3qZ","controller":"VerificationEdit_controller__Nosxp"};